import { action } from 'satcheljs';

/**
 * Hides the reading pane
 */
let hideReadingPane = action('hideReadingPane');
export default hideReadingPane;
